/**
 * web-home.js — renderer web-only delle sezioni homepage / custom-page.
 *
 * Caricato SOLO dalla shell PHP (window.TY_WEB === true), DOPO tutti gli
 * script nativi e js/web.js. Sul nativo questo file non esiste: l'app mobile
 * continua a renderizzare esattamente il suo subset di sezioni (home.js).
 *
 * Qui viene esteso il dispatcher updateSection() di home.js con la tecnica
 * capture-then-assign (nessuna function declaration che sovrascriva i nomi
 * nativi): le sezioni "web" vengono renderizzate con il markup della webapp
 * legacy (frontend/webapp/src/js/home.js) — stesse classi HTML, così gli
 * stili ereditati in css/home.css / css/main.css e i CSS custom del canale
 * si applicano senza modifiche.
 */

/* ------------------------------------------------------------------ *
 * Mappa di visibilità dei tipi sezione.
 * 'web'  => renderizzata da questo file (tyWebUpdateSection)
 * assente => passa al renderer nativo (home.js) invariato
 * ------------------------------------------------------------------ */
const TY_WEB_SECTION_TYPES = {
    header_section: 'web',
    header_slideshow_pack: 'web',
    custom: 'web',
    description_video: 'web',
    description_image: 'web',
    video: 'web',
    list_pack: 'web',
    list_premium_contents: 'web',
    list_categories: 'web',
    app_devices: 'web',
    faq: 'web',
    faq_and_reviews: 'web',
    brands: 'web',
    slider_images: 'web',
    testimonials: 'web',
    columns: 'web'
};

/* ------------------------------------------------------------------ *
 * 1. Dispatcher: capture-then-assign su updateSection (home.js)
 * Slideshow e spotlight passano SEMPRE all'hero "stile Netflix"
 * (web-hero.js): stesso markup su desktop e mobile/Capacitor, il layout
 * lo cambia il CSS (card cinematografica sopra i 992px, poster verticale
 * con azioni sotto l'artwork nell'app). Per tutti gli altri tipi il
 * flusso resta quello nativo/web esistente.
 * ------------------------------------------------------------------ */
var TY_WEB_HERO_TYPES = {
    header_slideshow_serie: 1,
    header_slideshow_pack: 1,
    collection_spotlight: 1
};

/* Dentro l'app Capacitor la HOME mostra solo slideshow, collection
 * spotlight, serie e video: le sezioni editoriali (brands, testimonials,
 * faq, colonne, immagini, app devices, ...) restano web-only e non vengono
 * nemmeno renderizzate, cosi' sul nativo non se ne scaricano i contenuti.
 * Il filtro NON vale per le pagine custom, che passano dallo stesso
 * renderer ma sono composte quasi solo da sezioni editoriali. */
var TY_WEB_NATIVE_SECTION_TYPES = {
    header_slideshow_serie: 1,
    collection_spotlight: 1,
    list_serie: 1,
    list_video: 1
};

// runtime nativo: html.ty-native e' l'hook impostato dalla shell (index.html),
// con fallback al check diretto sul bridge Capacitor
function tyWebIsNativeRuntime() {
    try {
        if (document.documentElement.classList.contains('ty-native')) {
            return true;
        }
        return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    } catch (err) {
        return false;
    }
}

// true sulla homepage (user/guest), false su una pagina custom attiva
function tyWebIsHomepageRender() {
    try {
        return !currentCustomPageActive ||
            currentCustomPageActive === 'user' ||
            currentCustomPageActive === 'guest';
    } catch (err) {
        return true;
    }
}

var tyNativeUpdateSection = updateSection;
updateSection = function (section, pos) {
    if (section && tyWebIsNativeRuntime() && tyWebIsHomepageRender() &&
        !TY_WEB_NATIVE_SECTION_TYPES[section.type]) {
        $('#positionSection' + pos).html('');
        return;
    }
    if (section && TY_WEB_HERO_TYPES[section.type]) {
        try {
            tyWebHeroSection(section, pos);
            return;
        } catch (err) {
            console.error('ty-web-home: errore hero, fallback nativo', err);
        }
    }
    if (section && TY_WEB_SECTION_TYPES[section.type] === 'web') {
        try {
            tyWebUpdateSection(section, pos);
        } catch (err) {
            console.error('ty-web-home: errore render sezione', section.type, err);
        }
    } else {
        tyNativeUpdateSection(section, pos);
    }
};

/* ------------------------------------------------------------------ *
 * 2. Homepage guest: capture-then-assign su loadHomepageSections.
 * Sul web, se l'utente NON è loggato e viene richiesta la homepage
 * utente ('1'/'user'), la scelta segue active_landing:
 * - standard => guest page
 * - catalog  => user page
 * - disabled => prompt login
 * Sul nativo la scelta è sempre user page.
 * ------------------------------------------------------------------ */
var tyNativeLoadHomepageSections = loadHomepageSections;
loadHomepageSections = function (type, company, isEditor = 0, version = null, page = null, idCustom = null) {
    if (typeof tyResolveHomePageTarget === 'function') {
        var homeTarget = tyResolveHomePageTarget(type, idCustom);
        if (homeTarget.shouldPromptLogin) {
            openModalLogin(true);
            return false;
        }
        type = homeTarget.type;
        idCustom = homeTarget.idCustom;
    } else {
        var isLogged = false;
        try {
            isLogged = (userData && userData.status == 'success');
        } catch (err) {}
        if (!isLogged && (type == '1' || type == 1 || idCustom == 'user')) {
            type = 0;
            idCustom = 'guest';
        }
    }
    return tyNativeLoadHomepageSections(type, company, isEditor, version, page, idCustom);
};

/* ------------------------------------------------------------------ *
 * 3. Call to action: capture-then-assign su getUrlCallToAction.
 * La versione nativa apre le pagine custom in un browser tab cordova
 * (inesistente sul web): qui 'page'/'link' restano in-app.
 * ------------------------------------------------------------------ */
var tyNativeGetUrlCallToAction = getUrlCallToAction;
getUrlCallToAction = function (type) {
    try {
        let valType = String(type).split('-');
        if (valType[0] == 'page') {
            openCustomPageLayer(valType[1]);
        } else if (valType[0] == 'link') {
            let target = String(type).substring(5);
            if (/^https?:\/\//.test(target)) {
                window.open(target, '_blank');
            } else {
                openCustomPageLayer(target);
            }
        } else if (valType[0] == 'serie' || valType[0] == 'video' || valType[0] == 'checkout') {
            tyNativeGetUrlCallToAction(type);
        } else {
            // Le route del sito partono dalla root, non dal <base> degli asset.
            window.location.href = new URL(type, window.location.origin + '/').href;
        }
    } catch (err) {}
};

/* ------------------------------------------------------------------ *
 * Pricing e checkout: NIENTE override qui — li fornisce web-payments.js
 * (caricato prima di questo file), con la versione completa: coupon,
 * rent, giftcard. tyWebStartCheckout usato dalle CTA arriva da lì.
 * ------------------------------------------------------------------ */

/* ------------------------------------------------------------------ *
 * Helpers
 * ------------------------------------------------------------------ */

// decodifica entità html (trick textarea, come nella webapp)
function tyWebDecodeHtml(text) {
    let elemArea = document.createElement('textarea');
    elemArea.innerHTML = text;
    return elemArea.value;
}

function tyWebEscapeAttr(text) {
    return String(text == null ? '' : text).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

// CTA email della landing guest ("Prova gratis con la tua e-mail"): avvia
// direttamente la REGISTRAZIONE con l'email già compilata — niente più
// lead capture add_contact
function tyWebLeadSubmit(form) {
    let email = $(form).find('input[type="email"]').val();
    if (!validateEmailInput(email)) {
        window.plugins.toast.showShortBottom(translate('ERROR'));
        return false;
    }
    tyWebAuthShow('register');
    // il form registrazione monta subito dopo: email precompilata
    setTimeout(function () {
        try { $('#reg_email').val(email); } catch (e) {}
    }, 150);
    return false;
}

// Slider "statico": se tutto il contenuto entra nel viewport dello slider
// non c'è nulla da scorrere — puntini e frecce spariscono e gli elementi
// si centrano. Ricontrollato al resize (debounce).
function tyWebTidySlider(rootSel) {
    function check() {
        $(rootSel).find('.swiffy-slider').each(function () {
            var c = this.querySelector('.slider-container');
            if (!c || c.offsetWidth === 0) { return; } // non ancora in layout
            this.classList.toggle('ty-slider-static', c.scrollWidth <= c.offsetWidth + 4);
        });
    }
    // il layout (fonti CSS, immagini, slider init) si assesta a ondate:
    // più passaggi, poi il resize tiene aggiornato
    [300, 1000, 2500].forEach(function (ms) { setTimeout(check, ms); });
    $(window).on('resize.tytidy', function () {
        clearTimeout(window.__tyTidyT);
        window.__tyTidyT = setTimeout(check, 250);
    });
}

// pausa gli iframe player quando escono dal viewport (parità webapp:
// setupVideoVisibilityControlHome, limitato alle sezioni renderizzate qui)
var tyWebIframeObserver = null;
function tyWebObserveSectionIframes(selector) {
    if (!('IntersectionObserver' in window)) {
        return;
    }
    if (!tyWebIframeObserver) {
        tyWebIframeObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) {
                    try {
                        entry.target.contentWindow.postMessage({ function: 'pause' }, '*');
                    } catch (err) {}
                }
            });
        }, { threshold: 0.3 });
    }
    setTimeout(function () {
        $(selector).find('iframe[src*="/video/player"]').each(function () {
            tyWebIframeObserver.observe(this);
        });
    }, 1000);
}

// accordion FAQ: stessa struttura bootstrap 3 della webapp (.collapse/.in);
// handler delegato, preventDefault obbligatorio (la shell ha <base href>)
$(document).on('click', '.sectionHomePageElement .panel-title a', function (e) {
    e.preventDefault();
    let $a = $(this);
    let target = $a.attr('href');
    $a.toggleClass('collapsed');
    $a.attr('aria-expanded', $a.hasClass('collapsed') ? 'false' : 'true');
    $(target).toggleClass('in');
    return false;
});

/* ------------------------------------------------------------------ *
 * Renderer sezioni web (porting da frontend/webapp/src/js/home.js).
 * Scrive negli stessi container #positionSection<pos> creati dal
 * flusso nativo (loadHomepageSections).
 * ------------------------------------------------------------------ */
function tyWebUpdateSection(json, i) {
    $('#positionSection' + i).html('');

    let sectionType = json.type;
    let htmlFinal = '';
    let mode = 'text-center';
    let title = '';
    let description = '';
    let categoriesParam = '';
    let callToAction = '';
    let backgroundVideo = '';
    let modeInputPosition = '';

    if (sectionType == 'header_section') {

        let overlayColor = '';
        if (json.val.overlayColor) {
            overlayColor = replaceAll(json.val.overlayColor, ';', ',');
            $('body').append('<style>#positionSection' + i + ' .hero-area::before{background:linear-gradient(' + overlayColor + ')!important;}</style>');
        } else {
            $('body').append('<style>#positionSection' + i + ' .hero-area::before{background:linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3))!important;}</style>');
        }

        let backgroundImage = '';
        if (json.val.background) {
            backgroundImage = "background: url('" + json.val.background + "');background-position:top; background-repeat: no-repeat; background-size: cover;";
        }

        if (json.val.mode == 'left') {
            mode = 'text-left';
        }

        if (json.val.title) {
            let decoded_title = tyWebDecodeHtml(getCurrentStringML(json.val.title, currentLang));
            let titleColor = '';
            if (json.val.titleColor) {
                titleColor = 'color:' + json.val.titleColor + ' !important;';
            }
            title = `<h1 style="${titleColor}" class="mt-2 bold title-section headerSectionTextColor h1SectionsHomepage">${decoded_title}</h1>`;
        }

        if (json.val.description) {
            let decoded_description = tyWebDecodeHtml(getCurrentStringML(json.val.description, currentLang));
            let descriptionColor = '';
            if (json.val.descriptionColor) {
                descriptionColor = 'color:' + json.val.descriptionColor + ' !important;';
            }
            description = `<p style="${descriptionColor}" class="pHomeStandard mt-2 headerSectionTextColor">${decoded_description}</p>`;
        }

        if (json.val.background_video_id) {
            backgroundVideo = `<iframe loading="lazy" id="headerBackgroundVideoIframe" allowfullscreen="true" autoplay webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" height="400" width="100%" src="/video/player?w=${json.val.background_video_id}&muted=on&controls=off&preview=on&auto=on&fillsize=on" scrolling="no"></iframe>`;
        }

        if (json.val.callToAction == 'registrationEmail') {
            if (!json.val.callToAction) {
                json.val.callToAction = translate('CONTINUE');
            }
            if (json.val.mode == 'left') {
                modeInputPosition = 'style="margin:unset;"';
            }
            // sulla webapp il form navigava su /register; qui il submit fa
            // lead capture diretto (add_contact) con toast di conferma
            callToAction = `<div class="start-with-email row" ${modeInputPosition}> <form onsubmit="return tyWebLeadSubmit(this);"> <div class="start-email-form-input"> <input name="email" id="subscriberEmailLead" type="email" class="input-from-send-group " placeholder="Email" required=""> <i></i> </div> <div class="start-email-form-button"> <button type="submit" class="button-primary btn-form-send-group">${getCurrentStringML(json.val.callToActionBtn, currentLang)}</button> </div> </form></div> `;
        } else {
            if (json.val.callToAction != '') {
                callToAction = `<a onclick="getUrlCallToAction('${tyWebEscapeAttr(json.val.callToAction)}')" class="button-primary headerStart mt-2">${getCurrentStringML(json.val.callToActionBtn, currentLang)}</a>`;
            }
        }

        let sectionHeight = '';
        if (json.val.sectionHeight) {
            if (json.val.sectionHeight == 'full-screen') {
                sectionHeight = 'height:100vh !important;';
                if (i == 1) {
                    sectionHeight += 'margin-top: -70px;';
                }
            }
        }

        $('#positionSection' + i).append(`<div style="${sectionHeight}${backgroundImage}" class="hero-area headerSection headerSection${i} headerBackgroundImage" id="home" >${backgroundVideo}<div class="col-md-12 hero-centered container"> 	<div class="hero-area-content ${mode}">${title}${description}${callToAction}</div></div></div>`);
        tyWebObserveSectionIframes('#positionSection' + i);

    } else if (sectionType == 'custom') {

        let customPadding = '';
        if (json.val.padding == 'true') {
            customPadding = 'container';
        }
        var content = json.val.content.replace(/&#039;/g, "'");
        $('#positionSection' + i).append(`<div class="${customPadding} about-area ptb-90 containerCustom${i}">${getCurrentStringML(content, currentLang)}</div>`);

    } else if (sectionType == 'header_slideshow_pack') {

        // stessa resa dello slideshow serie nativo: cambia solo l'endpoint
        // (già presente in json.endpoint), quindi si delega al renderer nativo
        let sectionAsSerie = Object.assign({}, json, { type: 'header_slideshow_serie' });
        tyNativeUpdateSection(sectionAsSerie, i);

    } else if (sectionType == 'description_video') {

        let colMdPush = '';
        let colMdPull = '';
        let idVideo = json.val.id;
        title = getCurrentStringML(json.val.title, currentLang);
        description = getCurrentStringML(json.val.description, currentLang);

        let overlayColor = '';
        if (json.val.overlayColor) {
            overlayColor = 'background:linear-gradient(' + replaceAll(json.val.overlayColor, ';', ',') + ')!important;';
        }

        if (json.val.align == 'right') {
            colMdPush = 'col-md-push-6';
            colMdPull = 'col-md-pull-6';
        }

        let htmlIframeVideo = '';
        if (idVideo) {
            htmlIframeVideo = `<iframe loading="lazy" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;" class="videoDescriptionVideo card2" src="/video/player?w=${idVideo}&auto=off" frameborder="0" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" scrolling="no"> </iframe>`;
        }

        let titleColor = '';
        if (json.val.titleColor) {
            titleColor = 'color:' + json.val.titleColor + ' !important;';
        }

        let descriptionColor = '';
        if (json.val.descriptionColor) {
            descriptionColor = 'color:' + json.val.descriptionColor + ' !important;';
        }

        if (json.val.callToAction != '') {
            callToAction = `<a onclick="getUrlCallToAction('${tyWebEscapeAttr(json.val.callToAction)}')" class="button-primary CallToAction mt-2 mb-2">${getCurrentStringML(json.val.callToActionBtn, currentLang)}</a>`;
        }

        htmlFinal = `<div class="container mt-5 mb-5 description_video_${i}" style="${overlayColor}"><div class="col-md-12 ">	<div class="col-md-6 ${colMdPush}"><div class="white text-left"><h1 style="${titleColor}" class="white mt-2 title-section h1SectionsHomepage bold">${title}</h1><p style="${descriptionColor}" class="pHomeStandard white mt-2">${description}</p>${callToAction}</div></div><div class="col-md-6 ${colMdPull}"><div class="mt-2" style="position: relative;padding-bottom: 56.25%;height: 0; overflow: hidden;">${htmlIframeVideo}</div></div></div></div>`;
        $('#positionSection' + i).append(htmlFinal);
        tyWebObserveSectionIframes('#positionSection' + i);

    } else if (sectionType == 'description_image') {

        let colMdPush = '';
        let colMdPull = '';
        let image = '';
        title = getCurrentStringML(json.val.title, currentLang);
        description = getCurrentStringML(json.val.description, currentLang);

        let overlayColor = '';
        if (json.val.overlayColor) {
            overlayColor = 'background:linear-gradient(' + replaceAll(json.val.overlayColor, ';', ',') + ')!important;';
        }

        if (json.val.align == 'right') {
            colMdPush = 'col-md-push-6';
            colMdPull = 'col-md-pull-6';
        }

        if (json.val.image != '') {
            image = json.val.image;
        }

        let titleColor = '';
        if (json.val.titleColor) {
            titleColor = 'color:' + json.val.titleColor + ' !important;';
        }

        let descriptionColor = '';
        if (json.val.descriptionColor) {
            descriptionColor = 'color:' + json.val.descriptionColor + ' !important;';
        }

        if (json.val.callToAction != '') {
            callToAction = `<a onclick="getUrlCallToAction('${tyWebEscapeAttr(json.val.callToAction)}')" class="button-primary CallToAction mt-2 mb-2">${getCurrentStringML(json.val.callToActionBtn, currentLang)}</a>`;
        }

        htmlFinal = `<div class="container mt-5 mb-5 description_image description_image_${json.val.align} description_image_${i}" style="${overlayColor}"><div class="col-md-12 ">	<div class="col-md-6 ${colMdPush}"><div class="white text-left description_image_text"><h1 style="${titleColor}" class="white mt-2 title-section h1SectionsHomepage bold">${title}</h1>	<p style="${descriptionColor}" class="pHomeStandard white mt-2">${description}</p>${callToAction}</div></div><div class="col-md-6 description_image_image ${colMdPull}"><img loading="lazy" src="${image}" width="100%" class="img_description mt-2"></div></div></div>`;
        $('#positionSection' + i).append(htmlFinal);

    } else if (sectionType == 'video') {

        let height = '50vh';
        if (json.val.mode == 'full') {
            height = '100vh';
        }

        htmlFinal = `<div style="width:100%; height:${height};">`;
        if (json.val.id != '') {
            htmlFinal += `<iframe loading="lazy" id="" allowfullscreen="true" autoplay webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" height="100%" width="100%" src="/video/player?w=${json.val.id}&auto=on" scrolling="no"></iframe>`;
        }
        htmlFinal += '</div>';

        $('#positionSection' + i).append(htmlFinal);
        tyWebObserveSectionIframes('#positionSection' + i);

    } else if (sectionType == 'list_pack') {

        let titleSection = getCurrentStringML(json.val.title_section, currentLang);
        if (json.val.id_cat) {
            if (Array.isArray(json.val.id_cat)) {
                categoriesParam = '&cat=' + json.val.id_cat[0];
            } else {
                categoriesParam = '&cat=' + json.val.id_cat;
            }
        }
        htmlFinal = `<div class="horizontalVideoGrid" id="liveHorizontalListPack${i}Box" ><h4 id="liveHorizontalListPack${i}Title" class="serie_title_main">${titleSection}</h4><div id="liveHorizontalListPack${i}" class="liveHorizontalListVideo"></div></div>`;
        $('#positionSection' + i).append(htmlFinal);
        getContentsHorizontal(json.endpoint, 1, '#positionSection' + i);

    } else if (sectionType == 'list_premium_contents') {

        let overlayColor = '';
        if (json.val.overlayColor) {
            overlayColor = 'background:linear-gradient(' + replaceAll(json.val.overlayColor, ';', ',') + ')!important;';
        }

        $('#positionSection' + i).append(`<div style="${overlayColor}" class="container list_premium_contents list_premium_contents${i}"><div class="text-center premiumContentsTitleBox"><h1 class="white premiumContentsTitleBoxLabel">${getCurrentStringML(json.val.title, currentLang)}</h1><p class="white pHomeStandard">${getCurrentStringML(json.val.description, currentLang)}</p></div></div>`);

        let options = {
            showImage: json.val.showImage
        };

        getListPricing('.list_premium_contents' + i, URL_API + '/collection/?f=get_payment_preview', options);

    } else if (sectionType == 'list_categories') {

        let titleListCategories = getCurrentStringML(json.val.title, currentLang);
        let show_title = json.val.show_title;
        let image = json.val.image;
        let classContainer = '';
        let classImage = '';
        let classImageClickbox = '';
        $('#positionSection' + i).html('<div class="listCategories listCategories' + i + '"></div>');

        $.ajax({
            type: 'GET',
            url: URL_API + '/categories/?f=get_categories&show=1&image=1',
            success: function (jsonCategories) {
                if (jsonCategories) {
                    let obj = JSON.parse(jsonCategories);
                    let resultLength = obj.length;
                    for (let k = 0; k < resultLength; k++) {
                        if (k == 0) {
                            htmlFinal += `<h4 class="serie_title_main">${titleListCategories}</h4><div class="sectionHomeListCategories sectionHomeListCategories${i}  ${classContainer}"><div class="swiffy-slider responsive-slide-movie slider-item-snapstart slider-nav-noloop slider-nav-sm slider-nav-autohide slider-nav-page"><ul class="slider-container">`;
                        }

                        if (image != 'show') {
                            classImage = 'class="grid-item"';
                        } else {
                            classImage = 'class="image-grid-cover"  style="background-image: url(' + obj[k].image + ');"';
                            try {
                                if (show_title == 'show') {
                                    classImageClickbox = 'image-grid-clickbox';
                                }
                            } catch (error) {}
                        }

                        let nameCat = getCurrentStringML(obj[k].name, currentLang);
                        let titleCat = '';
                        try {
                            if (show_title == 'show') {
                                titleCat = '<span class="cover-wrapper">' + nameCat + '</span>';
                            }
                        } catch (error) {}

                        htmlFinal += `<li><div onclick="clickedBrowseAll(${obj[k].id}, '', '${tyWebEscapeAttr(nameCat)}', false);" class="image-grid-item"><div ${classImage}><span  class="${classImageClickbox}"></span>${titleCat}</div></div></li>`;

                        if (k == resultLength - 1) {
                            htmlFinal += '</ul><button type="button" class="slider-nav"></button><button type="button" class="slider-nav slider-nav-next"></button></div></div>';
                            $('#positionSection' + i + ' .listCategories').append(htmlFinal);

                            try {
                                let currentSlid = document.querySelector('#positionSection' + i + ' .swiffy-slider');
                                swiffyslider.initSlider(currentSlid);
                            } catch (e) {
                                console.log('error-no-mode-present', e);
                            }
                        }
                    }
                }
            }
        });

    } else if (sectionType == 'app_devices') {

        var titleListAppDevices = getCurrentStringML(json.val.title, currentLang);
        let htmlDevices = '';
        $('#positionSection' + i).html('<div class="listAppDevices listAppDevices' + i + '"></div>');

        $('.listAppDevices' + i).append(`<h1 class="white bold text-center h1SezioniHomepage mt-5 mb-5">${titleListAppDevices}</h1>`);

        if (!json.val.image) {
            json.val.image = '/img/placeholder.png';
        }
        if (!json.val.image_app) {
            json.val.image_app = json.val.image;
        }
        if (!json.val.image_tv) {
            json.val.image_tv = json.val.image;
        }
        if (!json.val.image_tablet) {
            json.val.image_tablet = json.val.image;
        }
        if (!json.val.image_web) {
            json.val.image_web = json.val.image;
        }

        htmlDevices += `<div class="screens relative text-center margin-top-large margin-bottom-medium"><div class="deviceTV"><div class="device" style="background:url(/img/home/device_tv.png);"><img class="screen" src="${json.val.image_tv}"></div></div><div class="deviceTablet"><div class="device" style="z-index:2 !important; background:url(/img/home/device_tablet.png);"><img class="screen" src="${json.val.image_tablet}"></div></div><div class="devicePhone"><div class="device" style="z-index:2 !important; background:url(/img/home/device_phone.png);"><img class="screen" src="${json.val.image_app}"></div></div><div class="devicePC"><div class="device" style="z-index:2 !important; background:url(/img/home/device_pc.png);"><img class="screen" src="${json.val.image_web}"></div></div>`;

        // badge store: url della sezione, con fallback sugli id store del
        // canale se presenti; se mancano entrambi il badge non viene mostrato
        let iosUrl = json.val.ios_url;
        if (!iosUrl && typeof APPLE_STORE_ID !== 'undefined' && APPLE_STORE_ID) {
            iosUrl = 'https://apps.apple.com/app/id' + APPLE_STORE_ID;
        }
        let androidUrl = json.val.android_url;
        if (!androidUrl && typeof PLAY_STORE_ID !== 'undefined' && PLAY_STORE_ID) {
            androidUrl = 'https://play.google.com/store/apps/details?id=' + PLAY_STORE_ID;
        }
        let appletvUrl = json.val.appletv_url;
        let androidtvUrl = json.val.androidtv_url;

        if (androidUrl || iosUrl || appletvUrl || androidtvUrl) {
            htmlDevices += '<div class="col-md-12 alsoAvailableBox text-center" style="margin-top:90px;"><p class="white" style="margin-bottom:20px;">Also available on</p>';
            if (iosUrl) {
                htmlDevices += `<a class="appDevicesLink" target="_blank" href="${iosUrl}"><img src="/img/addons/app_ios.png" onerror="this.parentNode.style.display='none';"></a>`;
            }
            if (androidUrl) {
                htmlDevices += `<a class="appDevicesLink" target="_blank" href="${androidUrl}"><img src="/img/addons/app_android.png" onerror="this.parentNode.style.display='none';"></a>`;
            }
            if (appletvUrl) {
                htmlDevices += `<a class="appDevicesLink" target="_blank" href="${appletvUrl}"><img src="/img/addons/app_apple-tv.png" onerror="this.parentNode.style.display='none';"></a>`;
            }
            if (androidtvUrl) {
                htmlDevices += `<a class="appDevicesLink" target="_blank" href="${androidtvUrl}"><img src="/img/addons/app_android-tv.png" onerror="this.parentNode.style.display='none';"></a>`;
            }
            htmlDevices += '</div>';
        }

        htmlDevices += '</div>';
        $('.listAppDevices' + i).append(htmlDevices);

    } else if (sectionType == 'faq' || sectionType == 'faq_and_reviews') {

        var htmlTemp = '';
        var titleFaq = getCurrentStringML(json.val.title, currentLang);
        var questions = json.val.questions;
        var answers = json.val.answers;

        var lengthObjJson = questions.length;

        // details/summary nativi: niente dipendenza dal collapse bootstrap
        // (che nel capp non sempre risponde) e animazione garantita
        for (let z = 0; z < lengthObjJson; z++) {
            htmlTemp += `<details class="ty-faq-item"><summary><span>${getCurrentStringML(questions[z], currentLang)}</span><i class="ri-arrow-down-s-line"></i></summary><div class="ty-faq-body"><p>${getCurrentStringML(answers[z], currentLang)}</p></div></details>`;
        }

        htmlFinal = `<div class="faqs-reviews-contents"><section class="accordion-section clearfix mt-3" aria-label="Question Accordions"><div class="container"><h1 class="white bold text-center mb-3 h1SectionsHomepage">${titleFaq}</h1><div class="ty-faq">${htmlTemp}</div></div></section></div>`;

        $('#positionSection' + i).append(htmlFinal);

    } else if (sectionType == 'brands') {

        let htmlTemp = '';
        let titleBrands = getCurrentStringML(json.val.title, currentLang);
        let images = json.val.images;
        if (!images) {
            images = json.val.image; //fix old type
        }
        let urls = json.val.urls;
        if (!urls) {
            urls = json.val.url; //fix old type
        }
        if (!images) {
            images = [];
        }
        if (!urls) {
            urls = [];
        }

        let lengthObjJson = images.length;

        for (let z = 0; z < lengthObjJson; z++) {
            let stringUrl = urls[z] ? `target="_blank" href='${urls[z]}'` : 'disabled';
            htmlTemp += `<li><div class="" style="text-align:center;padding:5px;"><a ${stringUrl}><img loading="lazy" class="brands-section-logo-img"  src="${images[z]}"></a></div></li>`;
        }

        let sliderIndicator = '';
        if (lengthObjJson > 2) {
            for (let z = 0; lengthObjJson - 1 > z; z++) {
                sliderIndicator += '<button></button>';
            }
        }

        htmlFinal = `<div class="mt-4 mb-4 brandsList" id="brandsList${i}"><h1 class="white text-center h1SectionsHomepage">${titleBrands}</h1><div class="brandsItems mt-3"><div class="swiffy-slider slider-item-show6 slider-item-show2-sm slider-item-snapstart slider-nav-outside slider-nav-autohide slider-item-first-visible slider-indicators-round slider-indicators-outside slider-indicators-sm"><ul class="slider-container">${htmlTemp}</ul><div class="slider-indicators"><button class="active"></button>${sliderIndicator}</div></div></div></div>`;

        $('#positionSection' + i).append(htmlFinal);

        try {
            let currentSlid = document.querySelector('#brandsList' + i + ' .swiffy-slider');
            swiffyslider.initSlider(currentSlid);
        } catch (err) {}
        tyWebTidySlider('#brandsList' + i);

    } else if (sectionType == 'slider_images') {

        let htmlTemp = '';

        let images = [];
        if (json.val.images) {
            images = json.val.images;
        }
        let titles = [];
        if (json.val.titles) {
            titles = json.val.titles;
        }
        let descriptions = [];
        if (json.val.descriptions) {
            descriptions = json.val.descriptions;
        }
        let callToActions = [];
        if (json.val.callToActions) {
            callToActions = json.val.callToActions;
        }
        let callToActionBtns = [];
        if (json.val.callToActionBtns) {
            callToActionBtns = json.val.callToActionBtns;
        }

        let lengthObjJson = images.length;

        let overlayColor = '';
        if (json.val.overlayColor) {
            overlayColor = replaceAll(json.val.overlayColor, ';', ',');
            $('body').append('<style>#imagesSliderList' + i + ' .slide__content{background:linear-gradient(' + overlayColor + ')!important;}</style>');
        } else {
            $('body').append('<style>#imagesSliderList' + i + ' .slide__content{background:linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3))!important;}</style>');
        }

        let sliderSize = '';
        if (json.val.sliderSize == 'small') {
            sliderSize = 'height: 40vh !important;';
        }

        let titleColor = '';
        if (json.val.titleColor) {
            titleColor = 'color:' + json.val.titleColor + ' !important;';
        }

        let descriptionColor = '';
        if (json.val.descriptionColor) {
            descriptionColor = 'color:' + json.val.descriptionColor + ' !important;';
        }

        for (let z = 0; z < lengthObjJson; z++) {
            let displayCallToAction = '';
            if (callToActions[z]) {
                displayCallToAction = `<a onclick="getUrlCallToAction('${tyWebEscapeAttr(callToActions[z])}')" class="button-primary callToAction mt-2 mb-2 fadeInUp">${getCurrentStringML(callToActionBtns[z], currentLang)}</a>`;
            }

            htmlTemp += `<li><div class="slide" style="${sliderSize}"> <div class="slide__img" style="background: url('${images[z]}');"> </div> <div class="slide__content"> <div class="slide__content--headings text-center"> <h2 class=" slider_images_title fadeInUp" style="${titleColor}">${getCurrentStringML(titles[z], currentLang)}</h2><p class="pHomeStandard slider_images_description fadeInUp"  style="${descriptionColor}">${getCurrentStringML(descriptions[z], currentLang)}</p>${displayCallToAction}</div> </div> </div></li>`;
        }

        let sliderIndicator = '';
        for (let z = 0; lengthObjJson - 1 > z; z++) {
            sliderIndicator += '<button></button>';
        }

        htmlFinal = `<div class="mt-4 mb-4" id="imagesSliderList${i}"><div class="imagesItems"><div class="swiffy-slider slider-nav-sm slider-indicators-round slider-indicators-sm slider-nav-animation slider-nav-animation-fadein slider-nav-autohide"><ul class="slider-container">${htmlTemp}</ul><button type="button" class="slider-nav"></button><button type="button" class="slider-nav slider-nav-next"></button><div class="slider-indicators"><button class="active"></button>${sliderIndicator}</div></div></div></div>`;

        $('#positionSection' + i).append(htmlFinal);

        try {
            let currentSlid = document.querySelector('#imagesSliderList' + i + ' .swiffy-slider');
            swiffyslider.initSlider(currentSlid);
        } catch (err) {}
        tyWebTidySlider('#imagesSliderList' + i);

    } else if (sectionType == 'testimonials') {

        let htmlTemp = '';

        let images = [];
        if (json.val.images) {
            images = json.val.images;
        }
        let names = [];
        if (json.val.names) {
            names = json.val.names;
        }
        let quotes = [];
        if (json.val.quotes) {
            quotes = json.val.quotes;
        }

        let lengthObjJson = images.length;

        let overlayColor = '';
        if (json.val.overlayColor) {
            overlayColor = replaceAll(json.val.overlayColor, ';', ',');
            $('body').append('<style>#testimonialsList' + i + '{background:linear-gradient(' + overlayColor + ')!important;}</style>');
        } else {
            $('body').append('<style>#testimonialsList' + i + '{background:transparent;}</style>');
        }

        let nameColor = '';
        if (json.val.nameColor) {
            nameColor = 'color:' + json.val.nameColor + ' !important;';
        }

        let quoteColor = '';
        if (json.val.quoteColor) {
            quoteColor = 'color:' + json.val.quoteColor + ' !important;';
        }

        for (let z = 0; z < lengthObjJson; z++) {
            htmlTemp += `<li><div class="mb-3 sliderTestimonialItem"><img src="${images[z]}" width="194px"> <p class="pHomeStandard mt-2" style="${quoteColor}">${getCurrentStringML(quotes[z], currentLang)}</p><p class="pHomeStandard  slider_images_title" style="${nameColor}">${names[z]}</p> </div></li>`;
        }

        let sliderIndicator = '';
        for (let z = 0; lengthObjJson - 1 > z; z++) {
            sliderIndicator += '<button></button>';
        }

        htmlFinal = `<div class="container mt-3" id="testimonialsList${i}"><div class="swiffy-slider slider-item-show3 slider-item-snapstart slider-nav-outside slider-nav-autohide slider-item-first-visible slider-indicators-round slider-indicators-outside slider-indicators-sm"><ul class="slider-container">${htmlTemp}</ul><div class="slider-indicators"><button class="active"></button>${sliderIndicator}</div></div></div>`;

        $('#positionSection' + i).append(htmlFinal);

        try {
            let currentSlid = document.querySelector('#testimonialsList' + i + ' .swiffy-slider');
            swiffyslider.initSlider(currentSlid);
        } catch (err) {}
        tyWebTidySlider('#testimonialsList' + i);

    } else if (sectionType == 'columns') {

        let htmlTemp = '';
        let htmlImage = '';
        let htmlTitle = '';
        let htmlSubtitles = '';

        let titleColumns = getCurrentStringML(json.val.title, currentLang);

        let titles = json.val.titles || [];
        let subtitles = json.val.subtitles || [];
        let images = json.val.images || [];
        let callToActions = json.val.callToActions;
        let callToActionBtns = json.val.callToActionBtns;

        if (!callToActionBtns) {
            callToActionBtns = json.val.txtButtons;
        }
        if (!callToActions) {
            callToActions = json.val.urls;
        }
        if (!callToActionBtns) {
            callToActionBtns = [];
        }
        if (!callToActions) {
            callToActions = [];
        }

        let lengthObjJson = Math.max(titles.length, subtitles.length, callToActions.length, callToActionBtns.length, images.length);

        let columnNumber = 12;
        if (lengthObjJson == 2) {
            columnNumber = 6;
        }
        if (lengthObjJson == 3) {
            columnNumber = 4;
        }
        if (lengthObjJson == 4) {
            columnNumber = 3;
        }

        for (let z = 0; z < lengthObjJson; z++) {
            htmlImage = '';
            if (images[z]) {
                htmlImage = `<img class="column-image" src="${images[z]}">`;
            }
            htmlTitle = '';
            if (titles[z]) {
                htmlTitle = `<h3 class="column-title white xbold">${getCurrentStringML(titles[z], currentLang)}</h3>`;
            }
            htmlSubtitles = '';
            if (subtitles[z]) {
                htmlSubtitles = `<p class="column-subtitles pHomeStandard white">${getCurrentStringML(subtitles[z], currentLang)}</p>`;
            }

            let columnCallToAction = '';
            if (callToActions[z]) {
                columnCallToAction = `<a onclick="getUrlCallToAction('${tyWebEscapeAttr(callToActions[z])}')" class="button-secondary callToAction mt-2 mb-2">${getCurrentStringML(callToActionBtns[z], currentLang)}</a>`;
            }

            htmlTemp += `<div class="col-md-${columnNumber} text-center culumnImageTextItem">${htmlImage}${htmlTitle}${htmlSubtitles}${columnCallToAction}</div>`;
        }

        htmlFinal = `<div class="container text-center culumnImageText" id="columnList${i}"><h1 class="white text-center h1SectionsHomepage">${titleColumns}</h1><div class="columnItems row mt-3">${htmlTemp}</div></div>`;

        $('#positionSection' + i).append(htmlFinal);
    }
}
